import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';


@Component({
    selector: 'app-copy-button',
    imports: [],
    templateUrl: './copy-button.component.html',
    styleUrls: ['./copy-button.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush //we don't to check for changes. so we can also use the onpush strategy. Please mark as dirty if changes are done
})
export class CopyButtonComponent {
  @Input() value!: string;
  @Input() label: string = "Copy";
  @Input() appearance: string = "default";
  success: boolean = false;
  timerId : any;

  constructor(private cdr: ChangeDetectorRef){}

  changeState(){
    this.success = false;
    clearTimeout(this.timerId);
    this.cdr.markForCheck();
  }

  copyVal()
  {
    console.log("Copy : ", this.value);
    navigator.clipboard.writeText(this.value).then(
      val => {
        this.success = true;
        this.cdr.markForCheck();
        this.timerId = setTimeout(this.changeState.bind(this), 3000);
      }
    );
  }
}
